import React, { useContext, useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { IonContent, IonPage, IonSpinner } from "@ionic/react";

// import Home from '../pages/Home';
import Pessoas from "../pages/Pessoas";
import Documentos from "../pages/Documentos";
import Boletos from "../pages/Boletos";
import AberturaChamados from "../pages/AberturaChamados";
import Perfil from "../pages/Perfil";
import ControleDeAcesso from "../pages/ControleDeAcesso";
import Subcontas from "../pages/Subcontas";
import { TermosUso } from "../pages/TermosUso";
import PaginasPage from "../pages/Paginas";
import PaginaPage from "../pages/Pagina";
import AuthContext from "../contexts/auth";

// Tela de espera exibida enquanto os recursos (módulos) da unidade carregam.
const Carregando: React.FC = () => (
  <IonPage>
    <IonContent fullscreen>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "40vh" }}>
        <IonSpinner name="crescent" color="aster-primary" />
      </div>
    </IonContent>
  </IonPage>
);

const AppRoutes: React.FC = () => {
  const verificaSubconta =
    !localStorage.getItem("@auth:subconta") ||
    localStorage.getItem("@auth:subconta") === "";
  const { recursos, recursosCarregados, fetchRecursos } =
    useContext(AuthContext);

  useEffect(() => {
    fetchRecursos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Página inicial depois do login: Documentos tem prioridade.
  const paginaInicial = recursos.includes("Documentos")
    ? "/documentos"
    : recursos.includes("Bem-vindo")
    ? "/paginas"
    : "/contatos";

  return (
    <>
      <Route
        path="/"
        component={() =>
          verificaSubconta ? (
            <Redirect to={{ pathname: "/unidades" }} />
          ) : !recursosCarregados ? (
            <Carregando />
          ) : (
            <Redirect to={{ pathname: paginaInicial }} />
          )
        }
        exact={true}
      />
      <Route
        path="/contatos"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : Pessoas
        }
        exact={true}
      />
      <Route
        path="/boletos"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : Boletos
        }
        exact={true}
      />
      <Route
        path="/documentos"
        component={
          verificaSubconta
              ? () => <Redirect to={{ pathname: "/unidades" }} />
            : !recursosCarregados
            ? Carregando
            : recursos.includes("Documentos")
            ? Documentos
            : () => <Redirect to={{ pathname: "/" }} />
        }
        exact={true}
      />
      <Route
        path="/paginas"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : !recursosCarregados
            ? Carregando
            : recursos.includes("Bem-vindo")
            ? PaginasPage
            : () => <Redirect to={{ pathname: "/" }} />
        }
        exact={true}
      />
      <Route
        path="/paginas/:id"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : PaginaPage
        }
        exact={true}
      />
      <Route
        path="/abertura-de-chamados"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : AberturaChamados
        }
        exact={true}
      />
      <Route
        path="/perfil"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : Perfil
        }
        exact={true}
      />
      <Route
        path="/controle-de-acesso"
        component={
          verificaSubconta
            ? () => <Redirect to={{ pathname: "/unidades" }} />
            : ControleDeAcesso
        }
        exact={true}
      />
      <Route
        path="/subcontas"
        component={() => <Redirect to={{ pathname: "/unidades" }} />}
        exact={true}
      />
      <Route path="/unidades" component={Subcontas} exact={true} />
      <Route
        path="/cadastro"
        component={() => <Redirect to={{ pathname: "/" }} />}
        exact={true}
      />
      <Route path="/termos-de-uso" component={TermosUso} exact={true} />
    </>
  );
};

export default AppRoutes;
